import { render } from "./ContactIcon.vue?vue&type=template&id=19da62fa"
import script from "./ContactIcon.vue?vue&type=script&lang=js"
export * from "./ContactIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__